var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AlbumForm',_vm._g({staticStyle:{"width":"560px"},attrs:{"album":_vm.album}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }